import { NextPage, NextPageContext } from 'next'
import { useRouter } from 'next/router'
import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import ProfileContext from '@/components/Context/ProfileContext'
import { useCreateSubscription } from '@/lib/hook/useSubscriptionMutation'
import logger from '@/lib/logger'
import Button from '../Common/Button'

const routeSubscriptionReturn = 'subscription_success'

type Props = {
  success?: boolean
  textButton?: string
}
const ButtonPremuinBasket: NextPage<Props> = ({
  success,
  textButton = 'web_button_add_subscription',
}) => {
  const router = useRouter()

  const [loadingSubmit, setloadingSubmit] = useState<boolean>(false)

  const { profile } = useContext(ProfileContext)

  const createSubscription = useCreateSubscription()

  useEffect(() => {
    success && toast.success(t({ id: 'web_register_success' }))
  }, [success])

  const handleSubscription = async () => {
    setloadingSubmit(true)

    const redirectUrlMandate = `${window.location.origin}/${router.asPath}?${routeSubscriptionReturn}=1`

    return createSubscription
      .mutateAsync({
        redirectUrl: redirectUrlMandate,
      })
      .then((res: any) => {
        if (res) {
          if (res?.url) {
            window.location.replace(res.url)
          } else if (res.reason_text) {
            toast.error(res.reason_text)
          } else {
            toast.error('Erreur création abonnement')
          }
        }
      })
      .finally(() => {
        setloadingSubmit(false)
      })
      .catch(logger.error)
  }

  if (profile?.groupSubscriptionActive) {
    return null
  }

  return (
    <Button
      fullWidth
      color={'secondary'}
      loading={loadingSubmit}
      onClick={handleSubscription}
      style={{
        borderRadius: 8,
        padding: '12px 24px',
        fontSize: 16,
        fontWeight: 700,
        textTransform: 'none',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      }}
    >
      {t({ id: textButton })}
    </Button>
  )
}
ButtonPremuinBasket.getInitialProps = async ({ query }: NextPageContext): Promise<Props> => {
  return {
    success: String(query?.success) === '1',
  }
}
export default ButtonPremuinBasket
